export const t = {
  bg:        '#231E1B',
  deepDark:  '#1A1410',
  panelBg:   '#1A1310',
  measureBg: '#231B14',
  darkBrown: '#271B13',
  transport: '#362820',
  medBrown:  '#56463C',
  gold:      '#D4A853',
  beige:     '#D3CCBD',
  lime:      '#9DDB17',
  amber:     '#DB9817',
  cream:     '#F4F1EB',
  pill:      '#D9D9D9',
} as const;

export type Token = (typeof t)[keyof typeof t];
